import './RuangList.css';
import axios from 'axios';
import { useEffect, useState } from "react";
import React from 'react';
import { useInterval } from '../../../utils/useInterval';
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';
const RuangList = ({sessionId,roleUser, handleJoinDiskusi,timesUp}) => {
    const [listRuangDiskusi, setlistRuangDiskusi] = useState([])
    useEffect(() => {
		axios.get(`https://backend-ta-wiyata.herokuapp.com/getall-ruangdiskusi/${sessionId}/`)
			.then(function (response) {
				setlistRuangDiskusi(response.data.data)
				console.log(response)
			})
			.catch((error) => {
				console.log(error)
			})
	}, [])
	useInterval(async () => {
		axios.get(`https://backend-ta-wiyata.herokuapp.com/getall-ruangdiskusi/${sessionId}/`)
            .then(function (response) {
                setlistRuangDiskusi(response.data.data)
            })
            .catch((error) => {
                console.log(error)
            })
	}, 3000)
	return (
        <div class="ruang">
            <h2 class="ruang__title">Discussion Room</h2>
            <Accordion allowMultipleExpanded={true} allowZeroExpanded={true}>
                { listRuangDiskusi.map((link,index) =>
                    <AccordionItem class="ruang__item-accordion" key={index}>
                        <AccordionItemHeading>
                            <AccordionItemButton class="ruang__list-item" >
                                <div class="ruang__list-item--title">{link.nama_ruang}</div>
                                <div class="ruang__list-item--icon-list">
                                    <div class="ruang__list-item--icon">
                                        {roleUser === 'HOST' && link.status_panggil_fasilitator ?
                                        <div class="ruang__list-item--icon--raisehand">
                                           <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M20.8172 3.625C20.3696 3.625 19.9404 3.80279 19.6239 4.11926C19.3075 4.43572 19.1297 4.86495 19.1297 5.3125V10.375H18.0047V3.0625C18.0047 2.61495 17.8269 2.18572 17.5104 1.86926C17.194 1.55279 16.7647 1.375 16.3172 1.375C15.8696 1.375 15.4404 1.55279 15.1239 1.86926C14.8075 2.18572 14.6297 2.61495 14.6297 3.0625V10.375H13.5047V1.9375C13.5047 1.48995 13.3269 1.06072 13.0104 0.744257C12.694 0.42779 12.2647 0.25 11.8172 0.25C11.3696 0.25 10.9404 0.42779 10.6239 0.744257C10.3075 1.06072 10.1297 1.48995 10.1297 1.9375V10.375H9.00469V4.1875C9.00469 3.73995 8.8269 3.31072 8.51043 2.99426C8.19396 2.67779 7.76474 2.5 7.31719 2.5C6.86963 2.5 6.44041 2.67779 6.12394 2.99426C5.80748 3.31072 5.62969 3.73995 5.62969 4.1875V16.3487L3.13219 12.2987C2.89648 11.9168 2.5187 11.6442 2.08198 11.5408C1.64525 11.4374 1.18535 11.5118 0.803437 11.7475C0.421525 11.9832 0.148891 12.361 0.0455117 12.7977C-0.0578677 13.2344 0.0164755 13.6943 0.252187 14.0763L3.97594 20.0837C4.47987 20.8986 5.18358 21.5712 6.02032 22.0378C6.85707 22.5044 7.79913 22.7495 8.75719 22.75H16.8797C18.3715 22.75 19.8023 22.1574 20.8572 21.1025C21.9121 20.0476 22.5047 18.6168 22.5047 17.125V5.3125C22.5047 4.86495 22.3269 4.43572 22.0104 4.11926C21.694 3.80279 21.2647 3.625 20.8172 3.625Z" fill="#DD4444"/>
                                            </svg>
                                        </div> : null}
                                        <div class={timesUp ? "ruang__button-join button-join--disable" : "ruang__button-join"} onClick={event => handleJoinDiskusi(link, event)}>Join</div>
                                    </div>
                                    {roleUser === 'HOST' && link.status_panggil_fasilitator ? <div class="ruang-item__raised-hand"></div> : null}
                                    <div class="ruang__list-item--icon--dropdown">
                                        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9.24003 12.4464L6.65003 9.85645C6.3291 9.53551 6.56028 9 6.99648 9H12.1765C12.6233 9 12.8463 9.54306 12.5329 9.85645L9.94292 12.4464C9.74819 12.6412 9.43477 12.6412 9.24003 12.4464Z" fill="#2B2B2B" stroke="#2B2B2B"/>
                                        </svg>
                                    </div>
                                </div>
                            </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                            <div class="ruang__members">
                                {link.peserta.length >0 ?
                                    link.peserta.map((peserta,index) =>
                                        <div class="ruang__members-item"  key={index}>
                                            <div>{peserta.nama_peserta} {peserta.role_peserta === 'STUDENT' ? <span>- {peserta.npm_peserta}</span>: null } </div>
                                            <div>{peserta.role_peserta === 'STUDENT' ? <span class="ruang__list--role">Student</span >: <span class="ruang__list--role">HOST</span> } </div>
                                        </div>
                                    )
                                    :
                                    <div>This room does not have participant</div>
                                }
                                   
                            </div>
                        </AccordionItemPanel>
                    </AccordionItem>
                
                )}
                
            </Accordion>
        </div>
	);
}
 
export default RuangList;

